import { jsx, Fragment } from 'react/jsx-runtime';
import { useCallback } from 'react';
import { useFileUploadContext } from '../../context.mjs';

function FileUploadFileList({ children }) {
  const { files, onFilesChange } = useFileUploadContext("FileUpload.FileList");
  const handleRemoveFile = useCallback(
    (file) => {
      onFilesChange((previousFiles) => {
        if (previousFiles !== void 0) {
          return previousFiles.filter((previousFile) => previousFile !== file);
        }
      });
    },
    [onFilesChange]
  );
  return /* @__PURE__ */ jsx(Fragment, { children: typeof children === "function" ? children({ files, onRemoveFile: handleRemoveFile }) : children });
}
FileUploadFileList.displayName = "FileUpload.FileList";

export { FileUploadFileList };
//# sourceMappingURL=FileList.mjs.map
